import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPlanOption } from '../../services/tournament.service';

@Component({
  selector: 'tou-item',
  templateUrl: 'tou-item.html',
  styleUrls:['./tou-item.scss']
})
export class TouItemComponent {
  @Output() public onClick = new EventEmitter();
  @Input() public item: IPlanOption;

  constructor() { }

}



